// extracted by mini-css-extract-plugin
export default {"container":"Detail_container__YxHrC","bandera":"Detail_bandera__pYwZc","name":"Detail_name__FewOC","detail":"Detail_detail__1dXF8"};